<template>
<v-container>
    <div>
        <v-card flat>
            <v-card-text>
                <center>
                    <h2>Service Details</h2>
                </center>
                <br />
                <div>
                    <v-row>
                        <v-col>
                            <row-view label="Name" v-bind:text="service.name"></row-view>
                        </v-col>
                        <v-col>
                            <row-view label="Description" v-bind:text="service.description"></row-view>
                        </v-col>
                    </v-row>
                </div>
            </v-card-text>
            <v-card-text align="right">
                <back-button @click="goBack()" />
            </v-card-text>
        </v-card>
    </div>
</v-container>
</template>

<script>
import appConstants from "@/utils/appConstants.js";
import BackButton from "@/components/BackButton.vue";

export default {
    components: {
        BackButton,
    },
    data: () => ({
        service: {},
        id: 0,
    }),
    mounted() {
        this.initialize();
    },
    methods: {
        async initialize() {
            this.id = this.$route.params.id;
            try {
                this.service = await this.getItem(
                    appConstants.SERVICES_API + "/" + this.id
                );
            } catch (error) {
                this.handleError(error);
            }
        },
    },
};
</script>
